<td colspan="2" class="total-row-cell"></td>
<td colspan="4" class="total-row-cell">
	<h4 class="text-bold mb-0">Total</h4>
</td>
<td class="total-row-cell">
	<span class="text-bold">${{ commitmentTotal.hourlyCommitment | longNumber }}/h</span>
</td>
<td class="total-row-cell">
	<span class="text-bold">${{ commitmentTotal.amortized | longNumber }}/mo</span>
</td>
<td class="total-row-cell">
	<span class="text-bold">{{ commitmentTotal.utilizationPercentage | percent }}</span>
</td>
<td class="total-row-cell">
	<span class="text-bold">{{ commitmentTotal.savingsPercentage | percent }}</span>
</td>
<td class="total-row-cell">
	<span class="text-bold">${{ commitmentTotal.savings | longNumber }}</span>
</td>
